export default __webpack_public_path__ + "static/media/shortcut_key.9882b116.svg";